import { render, staticRenderFns } from "./reviewProcess.vue?vue&type=template&id=186219d2"
import script from "./reviewProcess.vue?vue&type=script&lang=js"
export * from "./reviewProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports